<template>
    <div id="FeedAluno">
        <vuestic-modal ref="modalCadastro" :cancelClass="'none'" :okClass="'none'" @closeEvent="closeModal">
            <div slot="title">Adicionar</div>
            <div class="form-elements">
                <div class="row" v-if="id_role == 2">
                    <fieldset class="col-12">
                        <legend>Autoescola</legend>
                        <model-select :options="selectCFC" v-model="inputs.cfc"
                            placeholder="Não selecione uma auto escola para um post publico">
                        </model-select>
                        <p class="aviso-postpublico">OBS: Não selecione uma auto escola para um post público</p>
                    </fieldset>
                </div>
                <div class="row mt-3">
                    <fieldset class="col-12">
                        <legend>
                            <span>Título</span>
                        </legend>
                        <div class="input-group input-group-lg">
                            <input type="text" class="form-control pt-0 pl-2 border rounded" v-model="inputs.titulo">
                        </div>
                    </fieldset>
                </div>
                <div class="row mt-3">
                    <fieldset class="col-12">
                        <legend>
                            <span>Descrição</span>
                        </legend>
                        <div class="input-group">
                            <textarea class="form-control pt-0 pl-2 border rounded" cols="30" rows="5" maxlength="500"
                                style="resize: none" v-model="inputs.descricao"></textarea>
                        </div>
                    </fieldset>
                </div>
                <div class="row mt-3 mb-5">
                    <fieldset class="col-12">
                        <legend>
                            <span>Imagem</span>
                        </legend>
                        <div class="input-group input-group-lg">
                            <div v-if="inputs.selectedImg == null">
                                <label class="btn btn-warning btn-sm" for="img">Carregar Foto</label>
                                <input type="file" id="img" accept="image/jpeg, image/jpg, image/png" @change="setImg"
                                    max-size="50">
                            </div>
                            <div class="col-12" v-else>
                                <img :src="inputs.selectedImg" for="img" class='w-100 imagem-modal'>
                                <span class="fa fa-close ml-2" title="Remover Foto" @click="clearImg('e')"
                                    style="position: absolute; justify-content: center; align-items: center; cursor:pointer">
                                </span>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="row mt3 d-flex justify-content-center">
                    <button class="btn btn-warning" @click="criarPost" :disabled="carregando">
                        <template v-if="!carregando">
                            Salvar
                        </template>
                        <component v-else :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'"
                            :size="20"></component>
                    </button>
                </div>
            </div>
        </vuestic-modal>

        <vuestic-modal ref="modalEditar" :cancelClass="'none'" :okClass="'none'" @closeEvent="closeModal">
            <div slot="title">Editar</div>
            <div class="form-elements">
                <div class="row mt-3">
                    <fieldset class="col-12">
                        <legend>
                            <span>Título</span>
                        </legend>
                        <div class="input-group input-group-lg">
                            <input type="text" class="form-control pt-0 pl-2 border rounded" v-model="inputs.titulo">
                        </div>
                    </fieldset>
                </div>
                <div class="row mt-3">
                    <fieldset class="col-12">
                        <legend>
                            <span>Descrição</span>
                        </legend>
                        <div class="input-group">
                            <textarea class="form-control pt-0 pl-2 border rounded" cols="30" rows="5" maxlength="500"
                                style="resize: none" v-model="inputs.descricao"></textarea>
                        </div>
                    </fieldset>
                </div>
                <div class="row mt-3 mb-5">
                    <fieldset class="col-12">
                        <legend>
                            <span>Imagem</span>
                        </legend>
                        <div class="input-group input-group-lg">
                            <div v-if="inputs.selectedImg == null">
                                <label class="btn btn-warning btn-sm" for="img">Carregar Foto</label>
                                <input type="file" id="img" accept="image/jpeg, image/jpg, image/png" @change="setImg"
                                    max-size="50">
                            </div>
                            <div class="col-12" v-else>
                                <img :src="inputs.selectedImg" for="img" class='w-100 imagem-modal'>
                                <span class="fa fa-close ml-2" title="Remover Foto" @click="clearImg('e')"
                                    style="position: absolute; justify-content: center; align-items: center; cursor:pointer">
                                </span>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="row mt3 d-flex justify-content-center">
                    <button class="btn btn-warning" @click="editarPost" :disabled="carregando">
                        <template v-if="!carregando">
                            Salvar
                        </template>
                        <component v-else :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'"
                            :size="20"></component>
                    </button>
                </div>
            </div>
        </vuestic-modal>

        <vuestic-modal ref="modalExcluir" :cancelClass="'none'" :okClass="'none'" @closeEvent="closeModal" small>
            <div slot="title">Excluir</div>
            <div class="form-elements">
                <div class="row mt3 d-flex justify-content-center">
                    <h5 class="mb-5">Confirmar exclusão do post.</h5>
                </div>
                <div class="row mt3 d-flex justify-content-center">
                    <button class="btn btn-warning" @click="excluirPost(modalDelete.id, modalDelete.schema)"
                        :disabled="carregando">
                        <template v-if="!carregando">
                            Confirmar
                        </template>
                        <component v-else :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'"
                            :size="20"></component>
                    </button>
                </div>
            </div>
        </vuestic-modal>

        <vuestic-modal ref="modalImagem" :cancelClass="'none'" :okClass="'none'" @closeEvent="closeModal">
            <div slot="title">Imagem</div>
            <div class="form-elements">
                <div class="row mt3 d-flex justify-content-center">
                    <img class="img-fluid imagem-modal" :src="modalImage.image" alt="Imagem do post">
                </div>
            </div>
        </vuestic-modal>

        <vuestic-modal ref="modalDescricao" :cancelClass="'none'" :okClass="'none'" @closeEvent="closeModal">
            <div slot="title">Descrição</div>
            <div class="form-elements">
                <div class="row mt3 d-flex justify-content-center">
                    <p>{{ modalDescricao.descricao }}</p>
                </div>
            </div>
        </vuestic-modal>

        <vuestic-widget headerText="Feed dos Alunos">
            <div class="row pt-3 mb-5" v-if="id_role == 2">
                <fieldset class="col-md-4 mb-3">
                    <legend>Autoescola</legend>
                    <model-select :options="selectCFC" v-model="inputs.cfc" placeholder="Selecione uma autoescola"
                        :disabled="carregando">
                    </model-select>
                </fieldset>

                <fieldset class="col-md-5" id="periodoConsultado">
                    <legend>Período a Ser Consultado</legend>
                    <div class="form-group">
                        <div class="col-md-6 p-0 pr-2">
                            <input type="date" class="form-control border rounded pl-2 pr-2"
                                v-model="inputs.dataInicio">
                        </div>
                        <div class="col-md-6 p-0 pl-2">
                            <input type="date" class="form-control border rounded pl-2 pr-2" v-model="inputs.dataFim">
                        </div>
                    </div>
                </fieldset>

                <div class="col-md-3 text-right">
                    <legend class="espacamento-oculto">.</legend>
                    <button class="btn btn-info col-12 btn-micro" @click="loadPosts" :disabled="carregando">
                        <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                        <span class="font-button-modified">Consultar</span>
                    </button>
                </div>
            </div>
            <div class="row pt-3">
                <button class="btn btn-block btn-micro btn-lg btn-warning col-3" @click="openModalCadastro"
                    :disabled="carregandoPosts">Adicionar</button>
            </div>

            <div class="row mt-5 d-flex justify-content-center" id="tabela">
                <!--Botões da paginação-->
                <div class="row">
                    <div class="col mx-auto">
                        <pagination :source="pagination" @navigate="navigate">
                        </pagination>
                    </div>
                </div>
                <!--Botões da paginação-->
                <div v-if="carregandoPosts" class="mx-5">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                    </component>
                </div>
                <table v-else class="table table-striped table-bordered table-responsive-sm text-center">
                    <thead>
                        <tr>
                            <th style="width:200px">Imagem</th>
                            <th>Título</th>
                            <th>Descrição</th>
                            <th>Data da publicação</th>
                            <th>Auto Escola</th>
                            <th>Publicado Por</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="posts.length === 0">
                            <td colspan="10">Nenhum Registro Encontrado</td>
                        </tr>
                        <tr v-for="(post, index) in posts" :key="index" v-else>
                            <td>
                                <a class="imagemTable"
                                    @click="openModalImagem(`data:image/jpeg;base64,${post.img_base64}`)">
                                    <img class="img-fluid img-thumbnail imagem-table"
                                        :src="`data:image/jpeg;base64,${post.img_base64}`" alt="Imagem do post">
                                </a>
                            </td>
                            <td>{{ post.titulo }}</td>
                            <td class="table-descricao" @click="openModalDescricao(post.descricao)">{{
                                    `${post.descricao.substring(0, 20)}...`
                            }}</td>
                            <td>{{ post.data.split(' ')[0] }}</td>
                            <td>{{ post.schema }}</td>
                            <td>{{ post.autor.nome }}</td>
                            <td>
                                <!-- VISUALIZAR & EDITAR -->
                                <span>
                                    <button @click="openModalEditar(post)" class="btn btn-micro"
                                        :disabled="carregando || id_role != 2 && post.schema == 'public'">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                </span>

                                <!-- REMOVER -->
                                <span>
                                    <button @click="openModalExcluir(post.id, post.schema)" class="btn btn-micro"
                                        :disabled="carregando || id_role != 2 && post.schema == 'public'">
                                        <i class="fa fa-close"></i>
                                    </button>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!--Botões da paginação-->
                <div class="row">
                    <div class="col mx-auto">
                        <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center">
                        </pagination>
                    </div>
                </div>
                <!--Botões da paginação-->
            </div>
        </vuestic-widget>
    </div>
</template>

<script>

import { ModelSelect } from "vue-search-select";
import * as spinners from "epic-spinners";
import FeedController from "./FeedController.js";
import pagination from "../pagination/pagination.vue";
import urlApi from "@/router/urlApiV2";

export default {
    nome: "FeedAluno",
    components: {
        ModelSelect,
        ...spinners,
        pagination,
    },
    data() {
        return {
            id_role: localStorage.id_role,
            selectCFC: [],
            carregandoPosts: false,
            inputs: {
                cfc: '',
                titulo: '',
                descricao: '',
                selectedImg: null,
                dataInicio: '',
                dataFim: '',
            },
            posts: [],
            carregando: false,
            camposVazios: true,
            countResult: 0,
            pagination: "",
            consult: '',
            table: {
                current_page: "",
                data: "",
                first_page_url: "",
                from: "",
                last_page: "",
                last_page_url: "",
                next_page_url: "",
                path: "",
                per_page: "",
                prev_page_url: "",
                to: "",
                total: "",
                pages: [],
                load: false,
                tp: "",
            },
            modalEdit: {
                id: '',
            },
            modalDelete: {
                id: '',
                schema: '',
            },
            modalImage: {
                image: '',
            },
            modalDescricao: {
                descricao: '',
            },
        }
    },
    methods: {
        openModalCadastro() {
            this.$refs.modalCadastro.open();
        },
        openModalEditar(post) {
            // FeedController.getPost(id, (response) => {
            //     if (response.body.sucesso === false) {
            //         FeedController.launchToast('fa-warning', response.mensagem);
            //         this.carregandoPosts = false;
            //     } else {
            //         this.inputs.titulo = response.body.dados.titulo;
            //         this.inputs.descricao = response.body.dados.descricao;
            //         this.inputs.selectedImg = `data:image/jpeg;base64,${response.body.dados.imagem}`;
            //         this.modalEdit.id = id;
            //         this.$refs.modalEditar.open();
            //     }

            // });
            this.inputs.titulo = post.titulo;
            this.inputs.descricao = post.descricao;
            this.inputs.selectedImg = `data:image/jpeg;base64,${post.img_base64}`;
            this.modalEdit.id = post.id;
            this.inputs.cfc = post.schema;
            this.$refs.modalEditar.open();
            console.log(inputs);
        },
        openModalExcluir(id, schema) {
            this.$refs.modalExcluir.open();

            this.modalDelete.id = id;
            this.modalDelete.schema = schema;
        },
        openModalImagem(imagem) {
            this.$refs.modalImagem.open();

            this.modalImage.image = imagem;
        },
        openModalDescricao(descricao) {
            this.$refs.modalDescricao.open();

            this.modalDescricao.descricao = descricao;
        },
        setImg(event) {
            if (event.target.files[0].size < 1000000) {
                const files = event.target.files;

                const fileReader = new FileReader();

                fileReader.readAsDataURL(files[0]);

                fileReader.addEventListener('load', () => {
                    this.inputs.selectedImg = fileReader.result;
                })
            } else {
                FeedController.launchToast('fa-warning', 'A imagem selecionada é muito grande!');
            }
        },
        clearImg() {
            this.inputs.selectedImg = null
        },
        clearInputs() {
            this.inputs.cfc = '';
            this.inputs.titulo = '';
            this.inputs.descricao = '';
            this.inputs.selectedImg = null;
            this.inputs.dataInicio = '';
            this.inputs.dataFim = '';
        },
        loadPosts() {
            const data = {
                schema: this.inputs.cfc,
                periodo: [this.inputs.dataInicio, this.inputs.dataFim],
            };

            this.consult = `${urlApi}/alunos/feed/posts?schema=${this.inputs.cfc}&periodoI=${data.periodo[0]}&periodoF=${data.periodo[1]}`;

            this.carregandoPosts = true;

            FeedController.getPosts(data, (response) => {
                if (response.body.sucesso === false) {
                    FeedController.launchToast('fa-warning', response.body.dados);
                    this.carregandoPosts = false;
                } else {
                    this.callbackDataPaginate(response.body.dados);
                    this.posts = response.body.dados.data;
                    this.carregandoPosts = false;
                }
            });
        },
        criarPost() {
            let data = {
                schema: this.inputs.cfc,
                titulo: this.inputs.titulo,
                descricao: this.inputs.descricao,
                imagem: this.inputs.selectedImg
            };

            this.carregando = true;

            FeedController.criarPost(data, (response) => {
                if (response.data.sucesso === false) {
                    FeedController.launchToast('fa-warning', response.data.mensagem);

                    this.carregando = false;
                } else {
                    this.carregando = false;
                    FeedController.launchToast('fa-check', response.data.mensagem);
                    this.$refs.modalCadastro.close();
                    this.loadPosts();
                }
            });
        },
        editarPost() {
            const id = this.modalEdit.id;
            const data = {
                schema: this.inputs.cfc,
                titulo: this.inputs.titulo,
                descricao: this.inputs.descricao,
                imagem: this.inputs.selectedImg,
            };

            this.carregando = true;

            FeedController.editPost(id, data, (response) => {
                if (response.body.sucesso === false) {
                    FeedController.launchToast('fa-warning', response.data.mensagem);
                    this.carregando = false;
                    this.$refs.modalEditar.close();
                } else {
                    FeedController.launchToast('fa-check', response.data.mensagem);
                    this.carregando = false;
                    this.$refs.modalEditar.close();
                    this.loadPosts();
                }
            });
        },
        excluirPost(id, schema) {
            let data = schema === 'public' ? { id: id, schema: '' } : { id: id, schema: schema }

            this.carregando = true;

            FeedController.excluirPost(data, (response) => {
                if (response.body.sucesso === false) {
                    FeedController.launchToast('fa-warning', response.body.mensagem);
                    this.$refs.modalExcluir.close();
                    this.carregando = false;
                } else {
                    FeedController.launchToast('fa-check', response.body.mensagem);
                    this.$refs.modalExcluir.close();
                    this.loadPosts();
                    this.carregando = false;
                }
            });
        },
        closeModal() {
            this.inputs.cfc = '';
            this.inputs.titulo = '';
            this.inputs.descricao = '';
            this.clearImg();
            this.carregando = false
        },
        carregaCfcs() {
            //CARREGAR CFC's
            FeedController.loadCfc().then((res) => {
                this.selectCFC = res;
            });
        },
        formatData(date) {
            const data = new Date(date);

            const yyyy = data.getFullYear();
            let mm = data.getMonth() + 1;
            let dd = data.getDate();
            let hour = data.getHours();
            let min = data.getMinutes();
            let sec = data.getSeconds();

            const dataFormatada = `${dd}/${mm}/${yyyy} ${hour}:${min}:${sec}`;

            return dataFormatada;
        },
        callbackDataPaginate(response) {
            let res = response;
            this.table.current_page = res.current_page;
            this.posts = res.data;
            this.table.first_page_url = res.first_page_url;
            this.table.from = res.from;
            this.table.last_page = res.last_page;
            this.table.last_page_url = res.last_page_url;
            this.table.next_page_url = res.next_page_url;
            this.table.path = res.path;
            this.table.per_page = res.per_page;
            this.table.prev_page_url = res.prev_page_url;
            this.table.to = res.to;
            this.table.total = res.total;
            this.table.pages = [];

            for (let i = 1; i <= res.last_page; i++) {
                this.table.pages.push(i);
            }

            this.table.load = false;
            this.pagination = res;
            this.tp = res.data.length;
        },
        async navigate(page) {
            this.table.load = true;
            this.carregandoPosts = true;

            await this.$http.get(`${this.consult}&page=${page}`).then(function (response) {
                console.log(response);
                this.callbackDataPaginate(response.body.dados);

                this.carregandoPosts = false;
            });
            this.table.load = false;
        },
    },
    created() {
        this.loadPosts();
        this.carregaCfcs();
    },
    watch: {
        inputs: {
            handler: function (val, oldVal) {
                const titulo = val.titulo;
                const descricao = val.descricao;

                if (titulo.length > 0 && descricao.length > 0 && this.inputs.selectedImg != null) {
                    this.camposVazios = false;
                } else {
                    this.camposVazios = true;
                }
            },
            deep: true
        }
    }
}

</script>

<style lang="scss" scoped>
input[type="file"] {
    display: none;
}

.imagem-table {
    object-fit: cover;
    width: 150px;
    height: 100px;
}

.table-descricao {
    color: #ffc20e;
    cursor: pointer;
}

.imagem-modal {
    object-fit: cover;
    width: 600px;
    height: 400px;
}

.aviso-postpublico {
    font-size: 12px;
    margin-left: 10px;
}

#tabela {
    .fa {
        width: 35px;
        height: 35px;
        line-height: 15px;
        margin: 0px;
    }

    td {
        width: auto !important;
    }

    .fa-edit {
        color: white;
        background-color: #20c997;
        border-color: #20c997;
        padding: 10px;
        border-radius: 50%;
        box-shadow: black;
    }

    .fa-edit:hover {
        background-color: #20c9967e;
    }

    .fa-close {
        color: white;
        background-color: #dc3545;
        border-color: #dc3545;
        padding: 10px;
        border-radius: 50%;
        box-shadow: black;
    }

    .fa-close:hover {
        background-color: #af5e66;
    }

    .btn {
        box-shadow: none;
        letter-spacing: 0px !important;
    }

    .btn.btn-micro {
        padding: 0.5rem !important;
        line-height: 1 !important;
        border-radius: 100% !important;
    }

    // BOTÃO VISUALIZAR E EDITAR AULA
    .btn.btn-success {
        background-color: #20c997;
        color: white;
        box-shadow: none;
    }

    .btn.btn-success:hover {
        background-color: #20c996c9;
    }

    .imagemTable {
        border: none;
        background: none;
    }
}
</style>
